import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getFacets = () => api.get("/facets").then((r) => r.data);
export const getLocations = () => api.get("/locations").then((r) => r.data);
export const getCity = (slug) => api.get(`/cities/${slug}`).then((r) => r.data);
export const listCities = () => api.get("/cities").then((r) => r.data);
export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
